const locale = {
  appName: 'Kiness',
  tagline: '连接家人，温暖相伴',
  signIn: '登录',
  signUp: '注册',
  signOut: '退出',
  email: '电子邮箱',
  password: '密码',
  name: '姓名',
  facilityCode: '机构代码',
  facilityCodeHint: '请向护理机构索取此代码',
  noAccount: '还没有账号？',
  haveAccount: '已有账号？',
  signingIn: '登录中…',
  creatingAccount: '注册中…',
  loginError: '无法登录 — 请检查邮箱和密码',
  registerError: '无法注册 — 请重试',
  welcomeBack: '欢迎回来',
  welcomeNew: '加入您的护理社区',
  selectResident: '本次更新关于哪位住户？',
  updatePlaceholder: '{name} 今天怎么样？',
  addPhoto: '添加照片',
  postUpdate: '发布更新',
  posting: '发布中…',
  postSuccess: '更新已发布 — 家属将收到通知',
  postError: '无法发布更新 — 请检查网络后重试',
  yourLovedOne: '您的亲人',
  familyFeed: '家人动态',
  tabFeed: '动态',
  tabRecord: '记录',
  tabCalendar: '日历',
  tabPhotos: '照片',
  noUpdates: '暂无更新 — 请稍后再来',
  pullRefresh: '下拉刷新',
  refreshing: '刷新中…',
  admin: '管理',
  dashboard: '概览',
  residents: '住户',
  familyLinks: '家属关联',
  staff: '员工',
  facility: '机构',
  residentsCount: '住户人数',
  familyLinked: '已关联家属',
  updatesToday: '今日更新数',
  addResident: '添加住户',
  editResident: '编辑',
  removeResident: '删除',
  firstName: '名',
  lastName: '姓',
  room: '房间号',
  save: '保存',
  cancel: '取消',
  addFamilyEmail: '通过邮箱添加家属',
  addStaffEmail: '通过邮箱添加员工',
  staffAdd: '添加',
  staffCount: '共 {count} 名员工',
  relationship: '关系',
  inviteSent: '邀请已就绪 — 对方可用机构代码注册',
  loading: '加载中…',
  installTitle: '将 Kiness 添加到主屏幕',
  installBody: '快速查看您亲人的最新动态',
  installButton: '添加到主屏幕',
  installDismiss: '暂不',
  language: '语言',
  chooseLanguage: '选择您的语言',
  chooseLanguageSub: '选择您的语言',
  changeLanguageHint: '之后可随时通过地球图标更改',
  english: 'English',
  chinese: '中文',
  newUpdate: '新动态',
  from: '来自',
  roomLabel: '房间',
  confirmRemove: '确定删除此住户？',
  staffPostTitle: '发布更新',
  adminTitle: '机构管理',
  linkedFamily: '已关联家属',
  pendingInvite: '待注册',
  noResidents: '暂无住户 — 请添加第一位住户',
  noStaff: '暂无员工',
  photoOptional: '照片（可选）',
  dashboardSettingUp: '正在设置您的面板…',
  dashboardEmptyHint: '添加第一位住户即可开始',
};

export default locale;
